export default {"src":"/_next/static/media/audio2.d62bca4b.svg","height":19,"width":14};